import { UserFilter } from "@coaching-culture/types";
import { Button, DateRangeButton, Flex, Select } from "@coaching-culture/ui";
import { FilterModal } from "components/FilterPanel";
import { endOfDay, startOfDay } from "date-fns";
import { useCallback, useState } from "react";

export type ReportProps = {
  options: { value: string; label: string }[];
  selected: string;
  onChange: (val: string) => void;
  filter: UserFilter;
  onFilterChange: (newFilter: UserFilter) => void;
  showFilterButton?: boolean;
};

export type ReportSelectorProps = ReportProps & {
  onExport: () => void;
  showDateRange?: boolean;
  dateRange?: [Date, Date] | null;
  onDateRangeChange?: (value: [Date, Date] | null) => void;
};

export const ReportSelector = ({
  options,
  selected,
  onExport,
  onChange,
  filter,
  onFilterChange,
  showFilterButton,
  dateRange,
  onDateRangeChange,
  showDateRange,
}: ReportSelectorProps) => {
  const [showFilters, setShowFilters] = useState(false);

  const onCancel = useCallback(
    (result: UserFilter) => {
      setShowFilters(false);
      if (result) {
        onFilterChange(result);
      }
    },
    [onFilterChange],
  );

  return (
    <>
      <FilterModal
        isOpen={showFilters}
        filter={filter}
        onClose={(result) => {
          onCancel(result);
        }}
      />
      <Flex mb={2} flexDirection={["column", "row"]}>
        <Select
          options={options}
          value={selected}
          mb={[2, 0]}
          onChange={(ev) => onChange(ev.target.value)}
          style={{ flex: 1 }}
        />
        {showDateRange && (
          <DateRangeButton
            ml={2}
            value={dateRange ?? null}
            onChange={(val) =>
              onDateRangeChange(
                val ? [startOfDay(val[0]), endOfDay(val[1])] : null,
              )
            }
            presets={[14, 30, 90, 180, 365]}
            nullLabel="All time"
          />
        )}
        <Button ml={[0, 2]} onClick={onExport} color="primary" minWidth={160}>
          Export CSV
        </Button>
        {showFilterButton && (
          <Button
            ml={[0, 2]}
            color="primary"
            onClick={() => setShowFilters(true)}
          >
            Filters ({filter.groups.length + filter.userFields.length})
          </Button>
        )}
      </Flex>
    </>
  );
};
